import { useEffect, useContext, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

import HeaderBar from "../../components/HeaderBar";
import PayRollLayoutWrapper from "../../components/PayRollLayoutWrapper";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ArrowLeft, CheckCircle2, XCircle } from "lucide-react";

const BASE_URL = "https://nissi-india.com";

const EmployeeApprovalDetails = () => {
  const { employeeId } = useParams();
  const navigate = useNavigate();

  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const primaryBtnClass = `bg-${baseColor}-${baseShade}`;
  const primaryHoverClass = `hover:bg-${baseColor}-700`;

  const finYearId = Number(localStorage.getItem("finYearId") || 0);
  const userId = Number(localStorage.getItem("userId") || 1);

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState("basic"); // basic | contact | personal | status
  const [deptMap, setDeptMap] = useState({});
const [desigMap, setDesigMap] = useState({});
const [countryMap, setCountryMap] = useState({});
const [stateMap, setStateMap] = useState({});
const [cityMap, setCityMap] = useState({});
const [districtMap, setDistrictMap] = useState({});

const [qualifications, setQualifications] = useState([]);
const [qualName, setQualName] = useState("");
const [qualYear, setQualYear] = useState("");
const [qualSelected, setQualSelected] = useState([]);

const [photoUploading, setPhotoUploading] = useState(false);
const [photoFile, setPhotoFile] = useState(null);

const [branchMap, setBranchMap] = useState({});
const [gradeMap, setGradeMap] = useState({});
const [schemeMap, setSchemeMap] = useState({});
// optional (only if you add APIs later)
const [shiftMap, setShiftMap] = useState({});
const [salaryBasisMap, setSalaryBasisMap] = useState({});






  const [data, setData] = useState({
    employeeMaster: null,
    employeeApprovalQueue: null,
    latestRemark: null,
  });

const loadMastersForDetails = async () => {
  if (!ensureFinYear()) return;

  try {
    const [deptRes, desigRes, cRes, sRes, diRes, ciRes] = await Promise.all([
  axios.get(`${BASE_URL}/api/employee-approval/departments`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/designations`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/countries`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/states`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/districts`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/cities`, { params: { finYearId } }),
]);


    // dept
    const deptRows = deptRes?.data?.data || [];
    const dMap = {};
    for (const d of deptRows) dMap[String(d.deptId)] = d.deptName;
    setDeptMap(dMap);

    // desig
    const desigRows = desigRes?.data?.data || [];
    const dgMap = {};
    for (const d of desigRows) dgMap[String(d.desigId)] = d.desigName;
    setDesigMap(dgMap);

    // country
    const countries = cRes?.data?.data || [];
    const cMap = {};
    for (const c of countries) cMap[String(c.countryId)] = c.countryName;
    setCountryMap(cMap);

    // state
    const states = sRes?.data?.data || [];
    const sMap = {};
    for (const s of states) sMap[String(s.stateId)] = s.stateName;
    setStateMap(sMap);

    // districts
const districts = diRes?.data?.data || [];
const dMap2 = {};
for (const d of districts) dMap2[String(d.districtId)] = d.districtName;
setDistrictMap(dMap2);


    // city
    const cities = ciRes?.data?.data || [];
    const ciMap = {};
    for (const c of cities) ciMap[String(c.cityId)] = c.cityName;
    setCityMap(ciMap);

    const [branchRes, gradeRes, schemeRes] = await Promise.all([
  axios.get(`${BASE_URL}/api/employee-approval/branches`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/grades`, { params: { finYearId } }),
  axios.get(`${BASE_URL}/api/employee-approval/schemes`, { params: { finYearId } }),
]);

const bMap = {};
(branchRes?.data?.data || []).forEach((b) => {
  const id = String(b.fld_branchid ?? b.branchId ?? b.BranchId ?? "");
  const name = b.fld_branchname ?? b.branchName ?? b.BranchName ?? "";
  if (id) bMap[id] = name;
});
setBranchMap(bMap);

const gMap = {};
(gradeRes?.data?.data || []).forEach((g) => {
  const id = String(g.gradeId ?? g.fld_gradeid ?? "");
  const name = g.gradeName ?? g.fld_gradename ?? "";
  if (id) gMap[id] = name;
});
setGradeMap(gMap);

const scMap = {};
(schemeRes?.data?.data || []).forEach((s) => {
  const id = String(s.schemeId ?? s.fld_schemeid ?? "");
  const name = s.schemeName ?? s.fld_schemename ?? "";
  if (id) scMap[id] = name;
});
setSchemeMap(scMap);


    
  } catch (err) {
    toast.error(err?.response?.data?.message || err?.message || "Failed to load masters");
  }
};

const loadQualifications = async () => {
  if (!ensureFinYear()) return;
  const res = await axios.get(`${BASE_URL}/api/employee-approval/${employeeId}/qualifications`, {
    params: { finYearId },
  });
  if (res?.data?.status) setQualifications(res.data.data || []);
};

const addQualification = async () => {
  if (!qualName.trim() || !qualYear) return toast.warn("Enter Qualification + Year of Completion");
  const res = await axios.post(`${BASE_URL}/api/employee-approval/${employeeId}/qualifications`, {
    finYearId,
    userId,
    qualificationName: qualName.trim(),
    completionYear: Number(qualYear),
  });
  if (res?.data?.status) {
    toast.success("Added");
    setQualName("");
    setQualYear("");
    setQualSelected([]);
    await loadQualifications();
  } else toast.error(res?.data?.message || "Failed");
};

const removeQualifications = async () => {
  if (qualSelected.length === 0) return toast.warn("Select qualification(s) to remove");
  const res = await axios.delete(`${BASE_URL}/api/employee-approval/${employeeId}/qualifications`, {
    data: { finYearId, qualificationIds: qualSelected },
  });
  if (res?.data?.status) {
    toast.success("Removed");
    setQualSelected([]);
    await loadQualifications();
  } else toast.error(res?.data?.message || "Failed");
};

const uploadPhoto = async () => {
  if (!photoFile) return toast.warn("Choose photo first");
  try {
    setPhotoUploading(true);
    const fd = new FormData();
    fd.append("photo", photoFile);
    fd.append("finYearId", String(finYearId));
    fd.append("userId", String(userId));

    const res = await axios.post(`${BASE_URL}/api/employee-approval/${employeeId}/photo`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res?.data?.status) {
      toast.success("Photo uploaded");
      setPhotoFile(null);
      await loadDetails(); // refresh fld_photo
    } else toast.error(res?.data?.message || "Upload failed");
  } catch (err) {
    toast.error(err?.response?.data?.message || err?.message || "Upload failed");
  } finally {
    setPhotoUploading(false);
  }
};




  const screenBadge = useMemo(() => "INFRA SCREEN : EMP APPROVAL DETAILS", []);

  const inputReadonly =
    `w-full px-4 py-2 rounded-xl border outline-none ` +
    (isDark
      ? "bg-gray-800/40 border-white/10 text-white"
      : "bg-white border-gray-200 text-gray-900");

  const labelBase = `text-sm font-semibold ${isDark ? "text-gray-200" : "text-gray-700"}`;

  const cardBase =
    `rounded-3xl border shadow-xl overflow-hidden ` +
    (isDark
      ? "border-white/10 bg-gradient-to-br from-white/15 to-white/5 backdrop-blur-md"
      : "border-gray-200 bg-white");

  const primaryBtn =
    `inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl text-white font-bold shadow-lg ` +
    `hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 bg-emerald-600 hover:bg-emerald-700`;

  const warnBtn =
    `inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl text-white font-bold shadow-lg ` +
    `hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 bg-amber-600 hover:bg-amber-700`;

  const backBtn =
    `inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl font-bold border transition-all duration-200 ` +
    (isDark ? "border-white/10 text-white hover:bg-white/10" : "border-gray-200 text-gray-800 hover:bg-gray-50");

  const ensureFinYear = () => {
    if (!finYearId) {
      toast.warn("Please select Financial Year.");
      return false;
    }
    return true;
  };

  const loadDetails = async () => {
    if (!ensureFinYear()) return;
    if (!employeeId) return toast.warn("employeeId missing in route");

    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/api/employee-approval/${employeeId}/details`, {
        params: { finYearId },
      });

      if (res?.data?.status) {
        setData(res.data.data || {});
      } else {
        toast.error(res?.data?.message || "Failed to load details");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Details load failed");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  loadMastersForDetails();
  loadDetails();
  loadQualifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [employeeId]);



  // Prefer approval queue (pending change) else master
  const aq = data.employeeApprovalQueue || {};
  const em = data.employeeMaster || {};

  const getVal = (field) => {
    const v = aq?.[field];
    if (v !== undefined && v !== null && String(v).trim() !== "") return v;
    return em?.[field] ?? "";
  };

const getDisplayVal = (field) => {
  const raw = getVal(field);

  if (field === "fld_deptid") return deptMap[String(raw)] || raw || "";
  if (field === "fld_desigid") return desigMap[String(raw)] || raw || "";

  if (field === "fld_countryid") return countryMap[String(raw)] || raw || "";
  if (field === "fld_stateid") return stateMap[String(raw)] || raw || "";
  if (field === "fld_districtid") return districtMap[String(raw)] || raw || "";
  if (field === "fld_cityid") return cityMap[String(raw)] || raw || "";

  if (field === "fld_branchid") return branchMap[String(raw)] || raw || "";
if (field === "fld_gradeid") return gradeMap[String(raw)] || raw || "";
if (field === "fld_schemeid") return schemeMap[String(raw)] || raw || "";

// optional later
if (field === "fld_shiftid") return shiftMap[String(raw)] || raw || "";
if (field === "fld_salarybasis") return salaryBasisMap[String(raw)] || raw || "";


  return raw ?? "";
};



  // Highlight fields that di======\tween master and approval queue (like ASP LightBlue)
const diffBg = (field) => {
    const a = aq?.[field];
    const m = em?.[field];
    if (a === undefined) return "";
    const as = a === null ? "" : String(a).trim();
    const ms = m === null || m === undefined ? "" : String(m).trim();
    if (as !== ms) return isDark ? "bg-sky-900/40" : "bg-sky-100";
    return "";
  };

  const approve = async () => {
    if (!ensureFinYear()) return;
    if (!employeeId) return;

    if (!window.confirm("Approve this employee?")) return;

    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/api/employee-approval/${employeeId}/approve`, {
        finYearId,
        userId,
      });

      if (res?.data?.status) {
        toast.success(res?.data?.message || "Approved");
        navigate("/payroll/employee-approval");
      } else {
        toast.error(res?.data?.message || "Approve failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Approve failed");
    } finally {
      setLoading(false);
    }
  };

  const disapprove = async () => {
    if (!ensureFinYear()) return;
    if (!employeeId) return;

    if (!window.confirm("Disapprove this employee?")) return;

    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/api/employee-approval/${employeeId}/disapprove`, {
        finYearId,
        userId,
      });

      if (res?.data?.status) {
        toast.success(res?.data?.message || "Disapproved");
        navigate("/payroll/EmployeeApprovalManagement");
      } else {
        toast.error(res?.data?.message || "Disapprove failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Disapprove failed");
    } finally {
      setLoading(false);
    }
  };

  const TabBtn = ({ id, label }) => (
    <button
      onClick={() => setTab(id)}
      className={`px-4 py-2 rounded-2xl text-sm font-extrabold border transition ${
        tab === id
          ? isDark
            ? "bg-white/10 border-white/10"
            : "bg-gray-100 border-gray-200"
          : isDark
          ? "border-white/10 hover:bg-white/5"
          : "border-gray-200 hover:bg-gray-50"
      }`}
      type="button"
    >
      {label}
    </button>
  );
const Field = ({ label, field }) => (
  <div>
    <div className={labelBase}>{label}</div>
    <input
      className={`${inputReadonly} ${diffBg(field)}`}
      value={String(getDisplayVal(field) ?? "")}
      readOnly
    />
  </div>
);



  return (
    <PayRollLayoutWrapper>
      <ToastContainer
        position="top-right"
        autoClose={2600}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        theme={isDark ? "dark" : "light"}
      />

      <div className={`min-h-screen p-6 ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">EMPLOYEE APPROVAL DETAILS</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />

        <div
          className={`mx-auto max-w-6xl p-6 mt-6 rounded-3xl shadow-2xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : `${currentSkin.glass} bg-white text-black border-gray-200`
          }`}
        >
          {/* Header row */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
            <div>
              <div className="text-2xl font-extrabold">
                Employee : <span className="text-sky-400">{String(getVal("fld_Employee") || getVal("fld_employee") || "")}</span>
              </div>
              <div className="text-sm opacity-70">
                Employee ID: {employeeId} • Pending values are highlighted (LightBlue)
              </div>
            </div>

            <div className="flex flex-wrap gap-3 justify-end">
              <button className={backBtn} onClick={() => navigate("/payroll/employee-approval")} type="button">
                <ArrowLeft className="w-4 h-4" />
                Back
              </button>

              <button className={primaryBtn} onClick={approve} disabled={loading} type="button">
                <CheckCircle2 className="w-4 h-4" />
                Approve
              </button>

              <button className={warnBtn} onClick={disapprove} disabled={loading} type="button">
                <XCircle className="w-4 h-4" />
                Disapprove
              </button>
            </div>
          </div>

          <div className={`px-4 py-2 rounded-2xl text-sm font-bold inline-block ${isDark ? "bg-blue-900/40 text-blue-100" : "bg-blue-100 text-blue-800"}`}>
            {screenBadge}
          </div>

          {/* Tabs like ASP */}
          <div className="mt-6 flex flex-wrap gap-2">
            <TabBtn id="basic" label="BASIC DETAILS" />
            <TabBtn id="contact" label="CONTACT INFORMATION" />
            <TabBtn id="personal" label="PERSONAL DETAILS" />
            <TabBtn id="status" label="STATUS" />
          </div>

          {/* CONTENT */}
          <div className={`${cardBase} p-6 mt-4`}>
            {loading ? (
              <div className="py-10 text-center opacity-70">Loading...</div>
            ) : (
              <>
                {tab === "basic" && (
                  <>
                    <div className="text-xl font-extrabold mb-4">Basic Details</div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* NOTE: field names use DB columns. If your details API returns different names, tell me the exact key and I’ll adjust. */}
                      <Field label="Department *" field="fld_deptid" />
                      <Field label="Designation *" field="fld_desigid" />

                      <Field label="Employee Code" field="fld_Employeecode" />
                      <Field label="Employee Name *" field="fld_Employee" />

                      <Field label="Last Name" field="fld_lname" />
                      <Field label="Father Name" field="fld_fathername" />

                      <Field label="Sex *" field="fld_gender" />
                      <Field label="Blood Group" field="fld_bloodgroup" />

                      <Field label="Date of Joining *" field="fld_dateofjoining" />
                      <Field label="Employee Type *" field="fld_typeid" />

                      <Field label="Bank Name" field="fld_bankname" />
                      <Field label="A/C Number" field="fld_accountno" />
                    </div>
                  </>
                )}

                {tab === "contact" && (
                  <>
                    <div className="text-xl font-extrabold mb-4">Contact Information</div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Field label="Temporary Address" field="fld_tempaddress" />
                      <Field label="Permanent Address" field="fld_permaddress" />

                      
                      <Field label="Country" field="fld_countryid" />
                      <Field label="State" field="fld_stateid" />
                      <Field label="District" field="fld_districtid" />
                      <Field label="City" field="fld_cityid" />

                      <Field label="Phone" field="fld_phone" />
                      <Field label="Mobile" field="fld_mobile" />

                      <Field label="Email" field="fld_emailid" />
                      
                    </div>
                  </>
                )}

                {tab === "personal" && (
  <>
    <div className="text-xl font-extrabold mb-4">Personal Details</div>

    {/* PHOTO UPLOAD + PRE EXP */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Photo */}
      <div className="p-4 rounded-2xl border border-gray-200 dark:border-white/10">
        <div className="font-extrabold mb-2">Photo</div>

        {(() => {
          const filename = (data?.employeeApprovalQueue?.fld_photo || data?.employeeMaster?.fld_photo || "").toString().trim();
          if (!filename) return <div className="text-sm opacity-70">No photo uploaded.</div>;
          return (
            <img
              alt="Employee"
              src={`${BASE_URL}/employee_photo/${filename}`}
              className="w-40 h-40 object-cover rounded-2xl border mt-2"
            />
          );
        })()}

        <div className="mt-3 flex flex-col gap-2">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setPhotoFile(e.target.files?.[0] || null)}
          />
          <button
            type="button"
            onClick={uploadPhoto}
            disabled={photoUploading}
            className="px-5 py-2 rounded-2xl bg-blue-600 text-white font-bold hover:bg-blue-700 disabled:opacity-60"
          >
            {photoUploading ? "Uploading..." : "Upload Photo"}
          </button>
          <div className="text-xs opacity-70">
            ASP requires photo before Approve.
          </div>
        </div>
      </div>

      {/* Pre Experience */}
      <div className="p-4 rounded-2xl border border-gray-200 dark:border-white/10">
        <div className="font-extrabold mb-2">Pre Experience</div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <div className={labelBase}>YY</div>
            <input className={inputReadonly} value={String(getVal("fld_preexpyrs") ?? "")} readOnly />
          </div>
          <div>
            <div className={labelBase}>MM</div>
            <input className={inputReadonly} value={String(getVal("fld_preexpmonths") ?? "")} readOnly />
          </div>
        </div>
      </div>
    </div>

    {/* Personal Fields */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
      <Field label="Marital Status" field="fld_maritalstatus" />
      <Field label="Date of Birth" field="fld_dateofbirth" />
      <Field label="PAN No" field="fld_PANno" />
      <Field label="Aadhar No" field="fld_Aadharcardnumber" />
      <Field label="Voter ID" field="fld_voterid" />
      <Field label="Driving Lic No" field="fld_drivinglicnum" />
      <Field label="Driving Lic Exp Date" field="fld_drivinglicexpdate" />
      <Field label="PF UAN No" field="fld_pfuanno" />
    </div>

    {/* QUALIFICATIONS (ASP grid) */}
    <div className="p-5 rounded-3xl border border-gray-200 dark:border-white/10">
      <div className="text-lg font-extrabold mb-3">Qualification</div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
        <div>
          <div className={labelBase}>Qualification</div>
          <input className={inputReadonly} value={qualName} onChange={(e) => setQualName(e.target.value)} />
        </div>
        <div>
          <div className={labelBase}>Year Of Completion</div>
          <input className={inputReadonly} value={qualYear} onChange={(e) => setQualYear(e.target.value)} />
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={addQualification}
            className="px-5 py-2 rounded-2xl bg-emerald-600 text-white font-bold hover:bg-emerald-700"
          >
            Add
          </button>
          <button
            type="button"
            onClick={removeQualifications}
            className="px-5 py-2 rounded-2xl bg-red-600 text-white font-bold hover:bg-red-700"
          >
            Remove
          </button>
        </div>
      </div>

      <div className="mt-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-700 text-white">
            <tr>
              <th className="px-3 py-2 text-center">S.No</th>
              <th className="px-3 py-2 text-center">Qualification</th>
              <th className="px-3 py-2 text-center">Year Of Completion</th>
              <th className="px-3 py-2 text-center">Delete</th>
            </tr>
          </thead>
          <tbody>
            {qualifications.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-3 py-6 text-center opacity-70">
                  No qualifications
                </td>
              </tr>
            ) : (
              qualifications.map((q, idx) => (
                <tr key={q.qualificationId} className="border-b">
                  <td className="px-3 py-2 text-center">{idx + 1}</td>
                  <td className="px-3 py-2 text-center">{q.qualificationName}</td>
                  <td className="px-3 py-2 text-center">{q.completionYear}</td>
                  <td className="px-3 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={qualSelected.includes(q.qualificationId)}
                      onChange={() =>
                        setQualSelected((prev) =>
                          prev.includes(q.qualificationId)
                            ? prev.filter((x) => x !== q.qualificationId)
                            : [...prev, q.qualificationId]
                        )
                      }
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  </>
)}


                {tab === "status" && (
  <>
    <div className="text-xl font-extrabold mb-4">Status</div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* LEFT COLUMN */}
      <Field label="Gross Salary *" field="fld_grosssalary" />
      <Field label="Special HRA *" field="fld_SpecialHRA" />

      <Field label="Conveyance Allowance *" field="fld_conveyanceallowance" />
      <Field label="PF No *" field="fld_pfno" />

      <Field label="PF *" field="fld_pf" />
      <Field label="TDS *" field="fld_tds" />

      <Field label="PF UAN No *" field="fld_pfuanno" />
      <Field label="Grade *" field="fld_gradeid" />

      <Field label="Branch *" field="fld_branchid" />
      <Field label="ESI Number *" field="fld_ESIno" />

      <Field label="E.S.I. *" field="fld_esi" />
      <Field label="SSN Number" field="fld_ssnno" />

      <Field label="PAN Number" field="fld_PANno" />
      <Field label="Salary Basis *" field="fld_salarybasis" />

      <Field label="Shift *" field="fld_shiftname" />
      <Field label="CLA Allowance *" field="fld_claallowance" />

      <Field label="Salary Scheme *" field="fld_schemeid" />
      <Field label="Leave Opening Balance *" field="fld_leaveopeningbalance" />

      <Field label="Daily Bata" field="fld_dailybata" />
      <Field label="Income Tax" field="fld_incometax" />

      <Field label="Leave Per Month *" field="fld_leavepermonth" />
      <Field label="Payment Mode *" field="fld_paymode" />

      <Field label="Avail Leave" field="fld_availleave" />
      <Field label="IFSC Code" field="fld_IFSCCode" />

      <Field label="Aadhar Card Number" field="fld_Aadharcardnumber" />
      <Field label="Voter Id *" field="fld_voterid" />

      <Field label="Bonus Bata" field="fld_bonusbata" />
      <Field label="Title" field="fld_title" />

      {/* DETAILS textarea (full width) */}
      <div className="md:col-span-2">
        <div className={labelBase}>Details</div>
        <textarea
          className={`${inputReadonly} min-h-[120px]`}
          value={String(getDisplayVal("fld_details") ?? "")}
          readOnly
        />
      </div>
    </div>

    {/* Latest Remark */}
    <div className="mt-6">
      <div className="text-lg font-extrabold mb-2">Latest Remark</div>
      <div className={`p-4 rounded-2xl border ${isDark ? "border-white/10 bg-white/5" : "border-gray-200 bg-gray-50"}`}>
        <div className="text-sm font-bold">
          {data?.latestRemark?.fld_title || "-"}
        </div>
        <div className="text-sm whitespace-pre-wrap mt-2 opacity-80">
          {data?.latestRemark?.fld_details || "No remark."}
        </div>
        <div className="text-xs mt-3 opacity-60">
          {data?.latestRemark?.fld_remarkdate || ""}
        </div>
      </div>
    </div>
  </>
)}

              </>
            )}
          </div>

          <div className="mt-4 text-xs opacity-70">
            Note: Highlighted fields indicate pending changes from Approval Queue (like ASP LightBlue).
          </div>
        </div>
      </div>
    </PayRollLayoutWrapper>
  );
};

export default EmployeeApprovalDetails;
